import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY || '',
  },
});

if (appInsights.config.instrumentationKey) {
  console.log('Application Insights loaded');
} else {
  console.log('Application Insights failed to load');
}

appInsights.loadAppInsights();

export default appInsights;
